import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material/dialog';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, VehicleService, VehicleServiceApi } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';
import { HelperService } from '../../services/helper.service';
import { ExtLoopBackAuth } from 'src/app/shared/modules/ext-sdk/services/ext-sdk-auth.service';
export class VehicleDetailsTabServiceStatesComponent extends ABaseComponent {
    constructor(logger, ui, dss, dialog, helperService, auth) {
        super(logger);
        this.logger = logger;
        this.ui = ui;
        this.dss = dss;
        this.dialog = dialog;
        this.helperService = helperService;
        this.auth = auth;
    }
    set vehicleService(v) {
        this._vehicleService = v;
        this.changeHandle();
    }
    get vehicleService() {
        return this._vehicleService;
    }
    changeHandle() { }
    onServiceStateInserting(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                event.data.id = event.data.__KEY__;
                event.data.createdAt = new Date();
                const { id, username } = this.auth.getCurrentUserData();
                event.data.createdBy = { id, username };
                let { serviceStates } = this.vehicleService;
                serviceStates = [Object.assign({}, event.data, { __KEY__: undefined }), ...this.vehicleService.serviceStates];
                this.vehicleService.serviceStates = serviceStates; // Update the local state with predicted data
                // Call the API to add the new service state
                const updatedVehicleService = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { serviceStates })
                    .toPromise();
                // Update the local state with the response
                this.vehicleService.serviceStates = updatedVehicleService.serviceStates;
            }
            catch (error) {
                notify('Error inserting service state', 'error', 3000);
                console.error('Error inserting service state:', error);
                event.cancel = true;
            }
        });
    }
    onServiceStateUpdating(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const { serviceStates } = this.vehicleService;
                const index = serviceStates.findIndex((state) => state.id === event.key.id);
                if (index !== -1) {
                    serviceStates[index] = Object.assign({}, serviceStates[index], event.newData, { updatedAt: new Date() });
                    const { serviceStates: updatedServiceStates } = yield this.dss
                        .getApi(VehicleService)
                        .mySaveWithRelated(this.vehicleService.id, { serviceStates })
                        .toPromise();
                    this.vehicleService.serviceStates = updatedServiceStates;
                }
            }
            catch (error) {
                notify('Error updating service state', 'error', 3000);
                console.error('Error updating service state:', error);
                event.cancel = true;
            }
        });
    }
    onServiceStateRemoving(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { serviceStates } = this.vehicleService;
            const index = serviceStates.findIndex((state) => state.id === event.key.id);
            if (index !== -1) {
                serviceStates.splice(index, 1);
                const { serviceStates: updatedServiceStates } = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { serviceStates })
                    .toPromise();
                this.vehicleService.serviceStates = updatedServiceStates;
            }
        });
    }
}
